import { useMemo, type PropsWithChildren } from 'react';
import { StorageContext } from '@/contexts/StorageContext';
import { createDataStore, LocalStorageAdapter, MemoryStorageAdapter } from '@/storage';

/**
 * The single place in the application that decides where data lives.
 * Swapping to Supabase later means constructing a different adapter here.
 */
export function StorageProvider({ children }: PropsWithChildren) {
  const store = useMemo(() => {
    const adapter = LocalStorageAdapter.isAvailable()
      ? new LocalStorageAdapter()
      : new MemoryStorageAdapter();
    return createDataStore(adapter);
  }, []);

  return <StorageContext.Provider value={store}>{children}</StorageContext.Provider>;
}
